<script setup>
import { router } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';
import JoinProgramme from '@/Pages/Teams/Partials/JoinProgramme.vue';
import JoinTeam from '@/Pages/Teams/Partials/JoinTeam.vue';

const props = defineProps({
    availableTeams: Array,
    teamsExist: Boolean,
    DisplayProgramTypeOptions: Boolean
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

</script>

<template>
    <AppLayout title="Dashboard">

        <div class="container mx-auto flex flex-col lg:flex-row justify-between w-full">

            <div id="sos-programme-dashboard-sidebar" class="order-2 lg:order-1 w-full lg:w-1/4 xl:w-1/5 min-h-screen p-10 pt-5">
                <DashboardSidebar />
            </div>

            <div class="order-1 lg:order-2 w-full lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <div class="overflow-hidden">
                    <form id="joinProgrammeTeamForm" class="">
                        <!-- <JoinProgramme v-if="DisplayProgramTypeOptions" /> -->
                        <JoinTeam :availableTeams="availableTeams" :teamsExist="teamsExist" :DisplayProgramTypeOptions="DisplayProgramTypeOptions" />
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
